import Browser from "./components/Browser";
import Header  from "./components/Header";

function App() {
  return (
    <div className="App">
      <Header title='☁️ Cloud Kitchen 🍴'></Header>
      <Browser></Browser>
      <footer>
        {/* &copy; Sailesh Rajanala. Sri Paisa Industries. Adi Bhavan Ltd. */}
        &copy; Sailesh Rajanala 2024.
      </footer>
    </div>
  )
}

export default App
